import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { getDomain } from '@shared/utils/domain.utils';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const token = localStorage.getItem('token');

  const domain = getDomain();
  const hasToken = !!token;

  // En desarrollo local (localhost), solo omitimos si no hay token (E2E necesita los headers)
  if (domain === 'localhost' && !hasToken) {
    return next(req);
  }

  // Si la petición ya lleva X-Tenant-Domain (ej: AuthSsoPage la pone explícitamente), respetarlo
  let headers = req.headers.has('X-Tenant-Domain') ? req.headers : req.headers.set('X-Tenant-Domain', domain);
  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }
  const newReq = req.clone({ headers });

  return next(newReq);
}
